import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "4", x2: "20", y1: "9", y2: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "4", x2: "20", y1: "15", y2: "15", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "8", y1: "3", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "16", x2: "14", y1: "3", y2: "21", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Hash";
const Hash = memo(themed(Icon));
export {
  Hash
};
//# sourceMappingURL=hash.js.map
